import get from 'lodash.get';
import set from 'lodash.set';

const validate = values => {
  const errors = {};
  const puRoutePoint = get(values, 'routePoints[0]');
  const doRoutePoint = get(values, 'routePoints[1]');
  if (puRoutePoint?.placeType === 'AIRPORT' && !puRoutePoint?.airport?.noFlight) {
    if (!puRoutePoint?.airport?.terminal) {
      set(errors, 'routePoints[0].airport.terminal', 'This field is required');
    }

    if (puRoutePoint?.airport?.iata){
      if (!puRoutePoint?.airport?.autocompleteTerminal && !puRoutePoint?.airport?.noFlight) {
        set(errors, 'routePoints[0].airport.autocompleteTerminal', 'This field is required');
      }
      if (!puRoutePoint?.airport?.flight?.airline && !puRoutePoint?.airport?.noFlight) {
        set(errors, 'routePoints[0].airport.flight.airline', 'This field is required');
      }
      if (!puRoutePoint?.airport?.flight?.meetingArea && !puRoutePoint?.airport?.noFlight) {
        set(errors, 'routePoints[0].airport.flight.meetingArea', 'This field is required');
      }
      if (!puRoutePoint?.airport?.flight?.number && !puRoutePoint?.airport?.noFlight) {
        set(errors, 'routePoints[0].airport.flight.number', 'This field is required');
      }
    }
  }
  if (doRoutePoint?.placeType === 'AIRPORT') {
    if (!doRoutePoint?.airport?.terminal) {
      set(errors, 'routePoints[1].airport.terminal', 'This field is required');
    }
  }
  return errors;
};

export default validate;
